<template>
  <jump-header />
  <div
    :class="['columns', passWaxWidth ? 'max-page-width' : '']"
    :style="{ background: ondemandDetail.bgColour }"
  >
    <div class="columns-top">
      <div class="ondemand-img-wrapper">
        <img class="ondemand-img" :src="ondemandDetail.pictureUrl" alt="" />
        <div class="click-sum-wrapper">
          <i class="v-icon-play-small" size="10px" />
          <span>{{ fixNumToBig(ondemandDetail.countClickSum) }}</span>
        </div>
      </div>
      <div class="columns-top-right">
        <span class="columns-title">{{ ondemandDetail.name }}</span>
        <div class="columns-tags">
          <div
            class="tag-item"
            :style="{
              background: ondemandDetail.bgColour,
              filter: 'brightness(150%)',
            }"
          >
            ⭐{{ averageScore }}
          </div>
          <div
            class="tag-item"
            :style="{
              background: ondemandDetail.bgColour,
              filter: 'brightness(150%)',
            }"
          >
            {{ rankInfo }}
          </div>
        </div>
        <div class="columns-bottom">
          <div class="bottom-left">
            <div class="columns-category">
              <i class="v-icon-category"></i>
              {{ ondemandDetail.secondName }}
            </div>
            <div class="columns-anchors">
              <i class="v-icon-my"></i>
              {{ hostNickName }}
            </div>
          </div>
          <div class="bottom-right" @click="showLauchAppToast">
            <i class="v-icon-cha" />
            订阅
          </div>
        </div>
      </div>
    </div>
    <div class="intro-desc">
      <div class="column-title">{{ ondemandDetail.name }}</div>
      <div class="column-intro">{{ ondemandDetail.intro }}</div>
    </div>
    <div class="intro-anchor">
      <div class="divide"></div>
      <div class="anchor-title">主持人介绍</div>
      <div class="anchor-list">
        <div class="anchor-item" v-for="item in hostList" :key="item.id">
          <img :src="item.publicImage" alt="" />
          <div class="anchor-content">
            <span class="anchor-content-nickname">{{ item.nickname }}</span>
            <span class="anchor-content-num">已被{{ item.sumBeFocused }}人关注</span>
          </div>
          <div class="anchor-focus" @click="showLauchAppToast">
            <i class="v-icon-cha" />
            <span>关注 </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    :class="['popup-wrapper', passWaxWidth ? 'max-page-transform-width' : '']"
    :style="popupStyle"
    ref="popupRef"
  >
    <div class="popup-drag"></div>
    <div class="popup-header" ref="headerRef">
      <div :class="['popup-header-item', currentActive === 0 ? 'popup-header-item-active' : '']">
        <div class="popup-header-item-name">节目</div>
      </div>
      <div
        :class="['popup-header-item', currentActive === 1 ? 'popup-header-item-active' : '']"
        @click="showLauchAppToast"
      >
        <div class="popup-header-item-name">评价</div>
      </div>
    </div>
    <div class="popup-func" ref="funcRef">
      <div class="popup-func-btn" @click="playColumnsItem">
        <img src="~@/assets/image/play-pain.png" alt="" />
        <span>全部播放</span>
      </div>
      <div class="popup-func-collect" @click="showLauchAppToast">
        <i :style="{ color: '#656768' }" class="v-icon-collect" />
      </div>
      <div class="popup-func-sort" @click="changeSort">
        <img :src="order === -1 ? sortDown : sortUp" alt="" />
      </div>
      <div class="popup-func-download" @click="showLauchAppToast">
        <i class="v-icon-download-line" />
      </div>
      <div class="popup-func-select" @click="showSelectPopup = !showSelectPopup">
        <span>共{{ programCount }}集</span>
        <i :class="['v-icon-arrow-down', showSelectPopup ? 'arrow-down-rotate' : '']" />
      </div>
      <transition name="slide">
        <div class="func-select-popup" v-if="showSelectPopup">
          <div class="select-popup">
            <div
              :class="[
                'select-popup-item',
                splitStart === item.start ? 'select-popup-item-active' : '',
              ]"
              v-for="(item, index) in splitPageList"
              :key="index"
              @click.stop="handleClickSplitItem(item)"
            >
              {{ item.start + 1 + "~" + item.end }}
            </div>
          </div>
        </div>
      </transition>
    </div>
    <scroll
      :probeType="3"
      :pullUpLoad="true"
      class="popup-content"
      @isPullingUp="isPullingUp"
      ref="scrollRef"
    >
      <div>
        <van-overlay
          class-name="content-mask"
          :show="showSelectPopup"
          @click="showSelectPopup = false"
        />
        <ColumnsList :programList="programList" :splitStart="splitStart" />
      </div>
    </scroll>
  </div>
  <!-- <router-view v-slot="{ Component }">
    <transition appear name="slide">
      <component :is="Component" />
    </transition>
  </router-view> -->
</template>

<script>
import { Toast } from "vant";
import wxSdk from "@/http/wxApi.js";
import { useRoute } from "vue-router";
import JumpHeader from "@/components/Base/JumpHeader";
import Scroll from "@/components/Scroll/Scroll";
import ColumnsList from "@/views/ColumnsComponent/ColumnsList";
import { defineComponent, onMounted, ref, watch } from "vue";
import {
  showProgramDetailIntroByType,
  queryAnchorDetialsByColunmId,
  queryColumnsAverageScore,
  queryColumnRankInCategory,
  queryHistoryProgramByName,
} from "@/http/api.js";
import router from "@/router";

export default defineComponent({
  name: "ColumnsDetail",
  components: {
    ColumnsList,
    JumpHeader,
    Scroll,
  },
  setup() {
    const route = useRoute();
    const scrollRef = ref(null);
    const hostList = ref([]);
    const rankInfo = ref("");
    const averageScore = ref(0);
    const hostNickName = ref("");
    const ondemandDetail = ref({});
    const id = ref(0);
    const passWaxWidth = ref(false);
    let timer = null;

    const { ...dragWrapperLogicProps } = dragWrapperLogic(route, scrollRef);

    onMounted(() => {
      id.value = route.query.id;
      let innerWidth = window.innerWidth;
      if (innerWidth > 450) {
        passWaxWidth.value = true;
      }
      init();
    });

    const init = async () => {
      await getOndemandDetail();
      getHostData();
      getRankInfo();
      getAverageScore();
      resizeHook();
      wxShare();
    };

    const resizeHook = () => {
      window.addEventListener("resize", (e) => {
        if (timer) {
          return;
        }
        timer = setTimeout(() => {
          let innerWidth = window.innerWidth;
          if (innerWidth > 450) {
            passWaxWidth.value = true;
          }
          clearTimeout(timer);
        }, 300);
      });
    };

    const getOndemandDetail = async () => {
      const ondemand = await showProgramDetailIntroByType({
        operateId: id.value,
        operateType: 3,
      });
      ondemandDetail.value = ondemand.data.AudioVideo;
      ondemandDetail.value.bgColour = ondemandDetail.value.bgColour.replace(/\s/g, "");
      console.log(ondemandDetail.value);
    };

    const getHostData = async () => {
      const hostData = await queryAnchorDetialsByColunmId({ id: id.value });
      hostList.value = hostData.data;
      hostNickName.value = hostData.data.map((host) => host.nickname).join(",");
    };

    const getAverageScore = async () => {
      const result = await queryColumnsAverageScore({
        operateType: 3,
        operateId: ondemandDetail.value.id,
      });
      averageScore.value = result.data.toFixed(1);
    };

    const getRankInfo = async () => {
      const result = await queryColumnRankInCategory({
        columnsId: id.value,
      });
      if (result.code === 1) {
        rankInfo.value = `${result.name} No.${result.rank}`;
      }
    };

    const wxShare = () => {
      const _ondemandDetail = ondemandDetail.value;
      wxSdk.getJSSDK({
        title: _ondemandDetail.name,
        desc: _ondemandDetail.intro,
        linkurl: `https://app.gztv.com/hcfmshare/#/ColumnsDetail?id=${_ondemandDetail.id}`,
        img: _ondemandDetail.pictureUrl,
      });
    };

    return {
      hostList,
      rankInfo,
      scrollRef,
      passWaxWidth,
      hostNickName,
      averageScore,
      ondemandDetail,
      ...dragWrapperLogicProps,
    };
  },
});
// 拖动层
const dragWrapperLogic = (route, scrollRef) => {
  const order = ref(-1);
  const page = ref(1);
  const rows = ref(10);
  const headerRef = ref(null);
  const funcRef = ref(null);
  const popupRef = ref(null);
  const currentActive = ref(0);
  const popupStyle = ref({
    top: "140px",
    transform: "translate(-50%, 0)",
    transition: "all 0s ease-in-out",
  });
  const showSelectPopup = ref(false);
  const programCount = ref(0);
  const programList = ref([]);
  const totalPage = ref(0);
  const splitStart = ref(0);
  const splitPageList = ref([]);
  const MAX_TOP = ref(0);
  const sortDown = require("@/assets/image/sort-down.png");
  const sortUp = require("@/assets/image/sort-up.png");
  let distanceY = 0;
  let startY = 0;
  let translateYVal = 0;
  let isMouseDown = false;

  const getProgramList = async () => {
    const result = await queryHistoryProgramByName({
      flag: "set",
      columnsId: route.query.id,
      page: page.value,
      rows: rows.value,
      order: order.value,
    });
    programList.value = [...programList.value, ...result.data.pageList];
    programCount.value = result.data.totalCount;
    totalPage.value = result.data.totalPage;
  };

  const splitPage = (newVal, standard) => {
    let forNum = Math.ceil(newVal / standard);
    for (let i = 0; i < forNum; i++) {
      if (i === forNum - 1) {
        splitPageList.value.push({
          start: i * standard,
          end: newVal,
          page: i + 1,
          standard: standard,
        });
      } else {
        splitPageList.value.push({
          start: i * standard,
          end: (i + 1) * standard,
          page: i + 1,
          standard: standard,
        });
      }
    }
  };

  const showLauchAppToast = () => {
    Toast.fail("请下载APP使用");
  };

  const changeSort = () => {
    order.value = order.value === -1 ? 1 : -1;
    programList.value = [];
    getProgramList();
  };

  const playColumnsItem = () => {
    router.push({
      name: "ColumnsPlay",
      query: {
        id: programList.value[0].id,
        columnsId: programList.value[0].columnsId,
      },
    });
  };

  const handleClickSplitItem = (item) => {
    showSelectPopup.value = false;
    splitStart.value = item.start;
    page.value = item.page;
    rows.value = item.standard;
    programList.value = [];
    getProgramList();
    scrollRef.value.scroll.refresh();
  };

  const isPullingUp = async () => {
    if (page.value >= totalPage.value) {
      scrollRef.value.scroll.finishPullUp();
      return;
    }
    page.value++;
    await getProgramList();
    scrollRef.value.scroll.finishPullUp();
  };

  const touchStart = (e) => {
    distanceY = 0;
    startY = e.touches[0].pageY;
    translateYVal = parseInt(popupStyle.value.transform.substring(15).replace(/px\)/g, ""));
  };
  const touchMove = (e) => {
    e.preventDefault();
    distanceY = e.touches[0].pageY - startY;
    // 上移
    if (distanceY < 0) {
      if (translateYVal > -10 && translateYVal < 10) {
        return;
      }
      if (distanceY + translateYVal < 0) {
        return;
      }
      popupStyle.value.transform = `translate(-50%,${translateYVal + distanceY}px)`;
    }
    // 下移
    if (distanceY > 0) {
      if (translateYVal > MAX_TOP.value - 100) {
        return;
      }
      if (distanceY + translateYVal > MAX_TOP.value - 100) {
        return;
      }
      popupStyle.value.transform = `translate(-50%,${translateYVal + distanceY}px)`;
    }
  };
  const touchEnd = () => {
    if (distanceY > 0) {
      bodyDown();
    } else {
      bodyGrow();
    }
    distanceY = 0;
  };

  const mouseDown = (e) => {
    isMouseDown = true;
    distanceY = 0;
    startY = e.pageY;
    translateYVal = parseInt(popupStyle.value.transform.substring(15).replace(/px\)/g, ""));
  };

  const mouseMove = (e) => {
    if (isMouseDown) {
      const _translateYVal = translateYVal;
      distanceY = e.pageY - startY;
      // 上移
      if (distanceY < 0) {
        if (_translateYVal > -10 && _translateYVal < 10) {
          return;
        }
        if (distanceY + _translateYVal < 0) {
          return;
        }
        popupStyle.value.transform = `translate(-50%,${_translateYVal + distanceY}px)`;
      }
      // 下移
      if (distanceY > 0) {
        if (_translateYVal > MAX_TOP - 91) {
          return;
        }
        if (distanceY + _translateYVal > MAX_TOP - 91) {
          return;
        }
        popupStyle.value.transform = `translate(-50%,${_translateYVal + distanceY}px)`;
      }
    }
  };

  const mouseUp = () => {
    if (distanceY > 0) {
      bodyDown();
    } else {
      bodyGrow();
    }
    distanceY = 0;
    isMouseDown = false;
  };

  const fixNumToBig = (num) => {
    if (num < 10000) {
      return num;
    } else {
      return `${(num / 10000).toFixed(2)}万`;
    }
  };

  // 下拉
  const bodyDown = () => {
    popupStyle.value.transform = `translate(-50%,${popupRef.value.clientHeight - 100}px)`;
    popupStyle.value.transition = `all 0.5s ease-in-out`;
    setTimeout(() => {
      popupStyle.value.transition = `all 0s ease-in-out`;
    }, 500);
  };
  // 上拉
  const bodyGrow = () => {
    popupStyle.value.transform = "translate(-50%,0px)";
    popupStyle.value.transition = `all 0.5s ease-in-out`;
    setTimeout(() => {
      popupStyle.value.transition = `all 0s ease-in-out`;
    }, 500);
  };

  watch(
    programCount,
    (newVal) => {
      if (newVal > 0) {
        if (newVal <= 10) {
          splitPageList.value.push({
            start: 0,
            end: newVal,
          });
        } else if (newVal > 10 && newVal < 100) {
          splitPage(newVal, 10);
        } else if (newVal >= 100 && newVal < 500) {
          splitPage(newVal, 20);
        } else if (newVal >= 500) {
          splitPage(newVal, 50);
        }
      }
    },
    {
      immediate: true,
    }
  );

  onMounted(() => {
    MAX_TOP.value = popupRef.value.clientHeight;
    getProgramList();
    scrollRef.value.scroll.scrollTo(0, 1);
    headerRef.value.addEventListener("touchstart", touchStart, true);
    headerRef.value.addEventListener("touchmove", touchMove, true);
    headerRef.value.addEventListener("touchend", touchEnd, true);
    funcRef.value.addEventListener("touchstart", touchStart, true);
    funcRef.value.addEventListener("touchmove", touchMove, true);
    funcRef.value.addEventListener("touchend", touchEnd, true);
    headerRef.value.addEventListener("mousedown", mouseDown, true);
    headerRef.value.addEventListener("mousemove", mouseMove, true);
    headerRef.value.addEventListener("mouseup", mouseUp, true);
    funcRef.value.addEventListener("mousedown", mouseDown, true);
    funcRef.value.addEventListener("mousemove", mouseMove, true);
    funcRef.value.addEventListener("mouseup", mouseUp, true);
    setTimeout(() => {
      bodyDown();
    }, 2000);
  });

  return {
    showSelectPopup,
    splitPageList,
    currentActive,
    programCount,
    programList,
    popupStyle,
    splitStart,
    totalPage,
    headerRef,
    popupRef,
    sortDown,
    funcRef,
    sortUp,
    order,
    fixNumToBig,
    changeSort,
    isPullingUp,
    playColumnsItem,
    showLauchAppToast,
    handleClickSplitItem,
  };
};
</script>

<style lang="scss" scoped>
.columns {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  font-size: 16px;
  // max-width: 500px !important;
  // margin: 0 auto;

  .columns-top {
    display: flex;
    width: 100%;
    box-sizing: border-box;
    padding: 0 13px;
    padding-top: 60px;

    .ondemand-img-wrapper {
      position: relative;
      display: flex;
      justify-content: center;
      width: 106px;
      height: 106px;
      border-radius: 4px;

      .ondemand-img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }

      .click-sum-wrapper {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        padding: 5px 0;
        bottom: 0;
        left: 50%;
        flex-shrink: 0;
        background: rgba(83, 97, 118, 0.7);
        color: #ffffff;
        font-size: 12px;
        border-radius: 12px;
        transform: translate(-50%, 50%);

        & > span {
          transform: scale(0.9);
          flex-shrink: 0;
          margin-left: 3px;
        }
      }
    }

    .columns-top-right {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin-left: 10px;

      .columns-title {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        line-height: 25px;
      }

      .columns-tags {
        display: flex;
        align-items: center;
        margin-top: 5px;
        overflow: hidden;

        .tag-item {
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          border-radius: 4px;
          background: #484b63;
          height: 23px;
          padding: 0 10px;
          color: #d1ad0e;
          font-size: 12px;
          max-width: 110px;

          &:first-child {
            margin-right: 15px;
          }
        }
      }

      .columns-bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
        height: 40px;

        .bottom-left {
          display: flex;
          flex-direction: column;
          height: 100%;
          flex: 1;
          margin-right: 5px;
          justify-content: space-between;

          .columns-category {
            display: flex;
            align-items: center;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 17px;
            color: #fff;

            .v-icon-category {
              font-size: 14px;
              margin-right: 5px;
            }
          }

          .columns-anchors {
            display: flex;
            align-items: flex-start;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 17px;
            color: #fff;
            margin-top: 5px;

            .v-icon-my {
              font-size: 14px;
              margin-right: 5px;
            }
          }
        }

        .bottom-right {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 82px;
          min-width: 82px;
          height: 34px;
          background: #feffff;
          border-radius: 16px;
          font-size: 14px;
          color: #050505;
          font-family: PingFangSC-Regular, PingFang SC;

          .v-icon-cha {
            transform: rotate(45deg) !important;
            margin-right: 8px;
          }
        }
      }
    }
  }

  .intro-desc {
    width: 100%;
    box-sizing: border-box;
    padding: 0 13px;
    margin-top: 34px;

    .column-title {
      height: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #dadee6;
      line-height: 22px;
    }

    .column-intro {
      width: 100%;
      box-sizing: border-box;
      padding-left: 14px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #dadee6;
      line-height: 20px;
      margin-top: 7px;
    }
  }

  .intro-anchor {
    margin-top: 26px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 13px;

    .divide {
      width: calc(100% - 46px);
      margin: 0 auto;
      height: 1px;
      background: #979797;
      transform: scaleY(0.5);
      -webkit-transform: scaleY(0.5);
      transform-origin: 0 0;
      -webkit-transform-origin: 0 0;
    }

    .anchor-title {
      margin-top: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #fdffff;
      line-height: 22px;
    }

    .anchor-list {
      width: 100%;

      .anchor-item {
        display: flex;
        width: 100%;
        align-items: center;
        margin-top: 15px;

        & > img {
          width: 66px;
          height: 66px;
          border-radius: 8px;
        }

        .anchor-content {
          margin-left: 22px;
          display: flex;
          flex: 1;
          flex-direction: column;
          height: 50px;
          justify-content: space-between;

          .anchor-content-nickname {
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #fdffff;
          }

          .anchor-content-num {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #7f8c9d;
            line-height: 17px;
          }
        }

        .anchor-focus {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 10px;
          width: 65px;
          height: 28px;
          background: #465166;
          border-radius: 12px;
          font-size: 14px;
          color: #fdffff;

          .v-icon-cha {
            transform: rotate(45deg);
            margin-right: 3px;
          }
        }

        .anchor-focus-active {
          color: #909b9b;
        }
      }
    }
  }
}

.popup-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #feffff;
  border-radius: 16px 16px 0 0;
  z-index: 2;
  // max-width: 500px !important;
  left: 50%;

  .popup-drag {
    position: absolute;
    top: 4px;
    left: 50%;
    transform: translateX(-50%);
    width: 36px;
    height: 6px;
    border-radius: 3px;
    background: #bcbebd;
  }

  .popup-header {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
    box-sizing: border-box;
    padding: 0 16px;
    z-index: 9999;

    .popup-header-item {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #717374;
      font-size: 16px;
      width: 50px;
      font-weight: 600;
      font-family: PingFangSC-Semibold, PingFang SC;

      &:last-child {
        margin-left: 10px;
      }

      .popup-header-item-name {
        position: relative;
        z-index: 9;
      }
    }

    .popup-header-item-active {
      position: relative;
      z-index: 9;
      font-size: 20px;
      color: #2a2c2d;

      &::after {
        position: absolute;
        content: "";
        bottom: 0;
        left: 50%;
        width: 40px;
        height: 6px;
        border-radius: 3px;
        background: linear-gradient(45deg, #e73828, #f0a7a7);
        transform: translate(-50%, 1px);
      }
    }
  }

  .popup-func {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 50px;
    box-sizing: border-box;
    padding: 0 16px;
    border-bottom: 1px solid #e8e9ea;
    z-index: 9999;

    .popup-func-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100px;
      height: 30px;
      background: rgba(244, 95, 71, 0.8);
      border-radius: 15px;
      color: #e9e0e0;
      font-size: 13px;
      font-weight: 600;

      & > img {
        width: 12px;
        height: 12px;
        opacity: 0.8;
      }

      & span {
        margin-left: 3px;
      }
    }

    .v-icon-collect {
      font-size: 16px;
    }

    .popup-func-sort {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;

      & > img {
        width: 20px;
        height: 20px;
      }
    }

    .v-icon-download-line {
      font-size: 16px;
    }

    .popup-func-select {
      & span {
        font-size: 14px;
        color: #656768;
        margin-right: 4px;
      }
    }

    .func-select-popup {
      position: absolute;
      top: 50px;
      left: 0;
      width: 100%;
      height: auto;
      background: #fff;
      z-index: 9;
      box-sizing: border-box;
      padding: 0 16px 40px 16px;

      .select-popup {
        display: flex;
        flex-wrap: wrap;
        width: 100%;

        .select-popup-item {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 70px;
          height: 30px;
          background: #ecf3f6;
          border-radius: 4px;
          color: #656768;
          font-size: 14px;
          margin: 15px 15px 0 0;
        }

        .select-popup-item-active {
          background: #e36744;
          color: #e5eaef;
        }
      }
    }
  }

  .popup-content {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    bottom: 0;

    .content-mask {
      background: rgba(0, 0, 0, 0.5) !important;
    }
  }
}

.arrow-down-rotate {
  transform: rotate(-180deg);
  transition: all 0.3s linear;
}
</style>
